<template>
  <div class="report-radio-buttons-container">
    <div class="report-radio-buttons-title">
      {{
        title || adminText(&quot;shellAll.select_a_period_you_would_like_to_generate_a_statistics_for&quot;, &quot;Select a period you would like to generate a statistics for:&quot;)
      }}
    </div>
    <div class="report-radio-buttons">
      <div class="date-range-options">
        <button
          type="button"
          class="date-range-option"
          :class="{ checked: checkedReportOption === 1 }"
          @click="$emit('changeCheckedOption', 1)"
        >
          <span class="desktop-label">{{ adminText(&quot;shellAll.7d&quot;, &quot;7d&quot;) }}</span><span class="mobile-label">{{ adminText(&quot;shellAll.7_days&quot;, &quot;7 days&quot;) }}</span>
        </button>
        <button
          type="button"
          class="date-range-option date-range-option--14-days"
          :class="{ checked: checkedReportOption === 2 }"
          @click="$emit('changeCheckedOption', 2)"
        >
          <span class="desktop-label">{{ adminText(&quot;shellAll.14d&quot;, &quot;14d&quot;) }}</span><span class="mobile-label">{{ adminText(&quot;shellAll.14_days&quot;, &quot;14 days&quot;) }}</span>
        </button>
        <button
          type="button"
          class="date-range-option date-range-option--21-days"
          :class="{ checked: checkedReportOption === 4 }"
          @click="$emit('changeCheckedOption', 4)"
        >
          <span class="desktop-label">{{ adminText(&quot;shellAll.21d&quot;, &quot;21d&quot;) }}</span><span class="mobile-label">{{ adminText(&quot;shellAll.21_days&quot;, &quot;21 days&quot;) }}</span>
        </button>
        <button
          v-if="allowAllTime"
          type="button"
          class="date-range-option all-time-button"
          :class="{ checked: checkedReportOption === 5 }"
          @click="$emit('changeCheckedOption', 5)"
        >
          {{ adminText(&quot;shellAll.all_time&quot;, &quot;All Time&quot;) }}
        </button>
      </div>
      <date-picker
        :lang="isAdminLocalization ? $adminLocale() : undefined"
        :value="dateRange"
        :clearable="false"
        type="date"
        range
        :placeholder="adminText(&quot;shellAll.select_date_range&quot;, &quot;Select date range&quot;)"
        :disabled-date="maxDateRange && disabledDate"
        @change="$emit('changeDateRange', $event)"
      >
        <template v-slot:input="{}">
          <button
            type="button"
            class="date-picker-trigger"
            :class="{ checked: checkedReportOption === 3 }"
            @click="$emit('changeCheckedOption', 3)"
          >
            <v-icon class="calendar-icon">event</v-icon>
            <span class="custom-choice-label">
              {{
                checkedReportOption === 3
                  ? `${formatDate(dateRange[0], 'DD/MM')} - ${formatDate(dateRange[1], 'DD/MM')}`
                  : adminText(&quot;shellAll.custom_choice&quot;, &quot;Custom choice&quot;)
              }}
            </span>
          </button>
        </template>
        <i slot="icon-calendar" />
      </date-picker>
    </div>
  </div>
</template>

<script>
import AdminContext from '@/admin-i18n/context'
import { formatDate } from '@/utils'
import moment from 'moment/moment'
import DatePicker from 'vue2-datepicker'
import hrDateFormat from 'date-format-parse/lib/locale/hr'

DatePicker.locale('hr', { formatLocale: hrDateFormat, yearFormat: 'YYYY', monthFormat: 'MMM', monthBeforeYear: true }, true)

export default {
  mixins: [AdminContext],
  name: 'graph-date-filters',
  components: { DatePicker },
  props: {
    title: String,
    checkedReportOption: Number,
    dateFilterOptions: {
      type: Array,
      default: () => [],
    },
    dateRange: Array,
    maxDateRange: Number,
    allowAllTime: Boolean,
  },
  methods: {
    formatDate,
    disabledDate(date, currentValue) {
      if (currentValue.length !== 1) return false

      return (
        date < currentValue[0] || date > moment(currentValue[0]).add(this.maxDateRange - 1, 'd')
      )
    }},
}
</script>

<style>
.report-radio-buttons-title {
  font-family: 'Source Sans Pro', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16.8px;
  color: #979797;
  margin-top: 30px;
  margin-left: 20px;
  margin-bottom: 12px;
}

.report-radio-buttons {
  display: flex;
  gap: 6px;
  margin: 0 20px;
  align-items: center;
}

.date-range-options {
  align-items: flex-start;
  background: #f5f5f5;
  border: 1.5px solid #d9d9d9;
  border-radius: 12px;
  display: flex;
  gap: 4px;
  height: 43px;
  padding: 4px;
}

.date-range-option,
.date-picker-trigger {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: #979797;
  cursor: pointer;
  display: flex;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 14px;
  font-weight: 400;
  height: 32px;
  justify-content: center;
  line-height: 1.2;
  padding: 8px;
  white-space: nowrap;
}

.date-range-option.checked {
  background: #333;
  color: #fff;
}

.mobile-label,
.custom-choice-label {
  display: none;
}

div.mx-datepicker {
  display: flex;
  height: 40px;
  margin-left: 0;
  width: 40px;
}

.date-picker-trigger {
  background: #f5f5f5;
  border: 1.5px solid #d9d9d9;
  border-radius: 12px;
  height: 40px;
  padding: 7px;
  width: 40px;
}

.calendar-icon {
  color: #666 !important;
  font-size: 24px !important;
}

@media only screen and (max-width: 930px) {
  .report-radio-buttons {
    flex-wrap: nowrap;
    margin-left: 0;
  }

  .date-range-option {
    padding-left: 14px;
    padding-right: 14px;
  }

  div.mx-datepicker,
  .date-picker-trigger {
    width: 44px;
  }
}

.report-radio-buttons-container {
  margin-bottom: 44px;
}
</style>
